// extracted by mini-css-extract-plugin
export default {"erir":"styles_erir__x7ito","erir_info":"styles_erir_info__f5hn8","status":"styles_status__TyrE-"};